// extracted by mini-css-extract-plugin
export var styles = "page-title-module--styles--2ptVm";
export var zzz = "page-title-module--zzz--ru2V-";